import PropTypes from 'prop-types';
import React from 'react';

import Spinner from '@shared/Spinner';

import useAPI from '../../../hooks/useAPI';
import RuleSummary from './RuleSummary';

const HitDetailsMore = ({
  alertId,
  hitId,
  isRuleBased,
  isModelBased,
  isThresholdBased,
}) => {
  const res = useAPI(
    'get',
    'ScreenConsoleListApi',
    `alerts/${alertId}/hits/${hitId}`,
    '',
    false,
    '',
    false
  );
  const { response, isLoading, error } = res;

  if (error) {
    return <span>Error: {JSON.stringify(error)}</span>;
  }

  if (isLoading || !response) {
    return <Spinner center />;
  }

  return (
    <RuleSummary
      explanation={response.explanation}
      isRuleBased={isRuleBased}
      decision={response.decision}
      isModelBased={isModelBased}
      isThresholdBased={isThresholdBased}
    />
  );
};

HitDetailsMore.propTypes = {
  isModelBased: PropTypes.bool.isRequired,
  isRuleBased: PropTypes.bool.isRequired,
  isThresholdBased: PropTypes.bool.isRequired,
  alertId: PropTypes.string.isRequired,
  hitId: PropTypes.string.isRequired,
};

HitDetailsMore.displayName = 'HitDetailsMore';

export default HitDetailsMore;
